import { createAsyncAction, createAction } from "typesafe-actions";

import { ProcedureIndexStatusFilter, ProcedureIndexStatusResponse } from "../interfaces";
import { ProcedureIndexActionTypes } from "./constants";

export const getProcedureIndexStatus = createAsyncAction(
  ProcedureIndexActionTypes.GET_PROCEDURE_INDEX_STATUS,
  ProcedureIndexActionTypes.GET_PROCEDURE_INDEX_STATUS_SUCCESS,
  ProcedureIndexActionTypes.GET_PROCEDURE_INDEX_STATUS_FAILURE,
)<ProcedureIndexStatusFilter, ProcedureIndexStatusResponse, Error>();

export const setFilter = createAction(ProcedureIndexActionTypes.SET_FILTER)<ProcedureIndexStatusFilter | null>();
export const clear = createAction(ProcedureIndexActionTypes.CLEAR)();
